// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"460":"8a8397be","497":"45217f62","687":"78463388"}[chunkId] + ".chunk.js";
};